module.exports = __webpack_public_path__ + "img/kaochang.6c46f463.png";